import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'mealjunction-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'restaurant-website';

  constructor(private location: Location) {
    this.title = window.location.hostname.replace('.com','');
   }
}
